<template>
  <el-pagination
    v-if="showPagination && pagination"
    :page-size="pagination.perPage"
    :page-count="pagination.pageCount"
    :pager-count="pager"
    :current-page="pagination.currentPage"
    layout="prev, pager, next"
    :total="pagination.totalCount"
    @current-change="change"
  />
</template>

<script>
export default {
  name: 'PaginationCustom',
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    pager: {
      type: Number,
      default: 7,
    },
  },
  computed: {
    pagination() {
      return this.data && typeof this.data.totalCount !== undefined
        ? this.data
        : false
    },
    showPagination() {
      return (
        this.pagination &&
        (this.pagination.totalCount || 0) / (this.pagination.perPage || 1) > 1
      )
    },
  },
  methods: {
    change(page) {
      this.$emit('changed', page)
    },
  },
}
</script>
